import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductGroupDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class ProductGroupService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/product-groups';

  getAllProductGroups(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<ProductGroupDto>> { return this.http.get<PageResponse<ProductGroupDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state)); }
  getProductGroupById(id: number): Observable<ProductGroupDto> { return this.http.get<ProductGroupDto>(`${this.apiUrl}/${id}`); }
  createProductGroup(dto: ProductGroupDto): Observable<ProductGroupDto> { return this.http.post<ProductGroupDto>(this.apiUrl, dto); }
  updateProductGroup(id: number, dto: ProductGroupDto): Observable<ProductGroupDto> { return this.http.put<ProductGroupDto>(`${this.apiUrl}/${id}`, dto); }
  deleteProductGroup(id: number): Observable<void> { return this.http.delete<void>(`${this.apiUrl}/${id}`); }
}
